import { formatDollarAmount } from '@hero/hero-utils/currency';
import { getPerPlanLabel } from '@hero/hero-utils/membership';
const getSubscriptionPlanLabel = ({ description, name, monthly_fee, storefront_key, prepaid_amount }) => `${name || description} (${storefront_key || '-'}) (${formatDollarAmount(prepaid_amount || monthly_fee, true)} / ${getPerPlanLabel(storefront_key)})`;
export default getSubscriptionPlanLabel;
